// envelope — every ozpanel API response, admin or mailbox, is {ok, data?, error?}
// (internal/respond). One decode function for all of v2, not one per app.

export interface Envelope<T> {
  ok: boolean;
  data?: T;
  error?: string;
}

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

/** Reads a Response as an ozpanel envelope, throwing ApiError on ok:false or a non-2xx status. */
export async function readEnvelope<T>(res: Response): Promise<T> {
  let env: Envelope<T>;
  try {
    env = (await res.json()) as Envelope<T>;
  } catch {
    throw new ApiError(res.status, `non-JSON response (HTTP ${res.status})`);
  }
  if (!res.ok || !env.ok) {
    throw new ApiError(res.status, env.error || `request failed (HTTP ${res.status})`);
  }
  return env.data as T;
}
